import React, { useEffect, useState } from 'react';
import { sgsstCapacitaciones, getSgsstEmpleados } from '../services/api';
import SgsstTabs from '../components/SgsstTabs';
import { S, F, Grid, Grid3, Modal, useFlash, fdate, dateVal } from '../components/sgsstUi';

const TIPO = { induccion: 'Inducción', reinduccion: 'Reinducción', especifica: 'Específica', entrenamiento: 'Entrenamiento' };
const hoy = () => new Date().toISOString().slice(0, 10);
const VACIO = { tema: '', tipo: 'especifica', fecha: hoy(), duracion_horas: 1, modalidad: 'presencial', instructor: '', lugar: '', estado: 'realizada', observaciones: '', asistentes: [] };

export default function SgsstCapacitaciones() {
  const [lista, setLista] = useState([]);
  const [emp, setEmp] = useState([]);
  const [m, setM] = useState(null);
  const [msgNode, flash] = useFlash();
  const [busy, setBusy] = useState(false);
  const [addSel, setAddSel] = useState('');

  const load = () => sgsstCapacitaciones.list().then(r => setLista(r.data)).catch(() => {});
  useEffect(() => { load(); getSgsstEmpleados().then(r => setEmp(r.data)).catch(() => {}); }, []);

  const abrirEditar = async (c) => { try { const { data } = await sgsstCapacitaciones.get(c.id); setM({ id: c.id, form: { ...VACIO, ...data, fecha: dateVal(data.fecha), asistentes: data.asistentes || [] } }); } catch (e) { flash(false, 'No se pudo abrir'); } };

  const addAsistente = () => {
    if (addSel) { const e = emp.find(x => x.id === addSel); if (e && !m.form.asistentes.some(a => a.empleado_id === e.id)) m.form.asistentes.push({ empleado_id: e.id, nombre: e.nombre, documento: e.numero_documento, asistio: true }); }
    else m.form.asistentes.push({ empleado_id: null, nombre: '', documento: '', asistio: true });
    setM({ ...m }); setAddSel('');
  };
  const setAsis = (i, k, v) => { m.form.asistentes[i][k] = v; setM({ ...m }); };
  const delAsis = (i) => { m.form.asistentes.splice(i, 1); setM({ ...m }); };

  const guardar = async () => {
    if (!m.form.tema?.trim()) return flash(false, 'Indica el tema');
    setBusy(true);
    try { if (m.id) await sgsstCapacitaciones.update(m.id, m.form); else await sgsstCapacitaciones.create(m.form); setM(null); load(); flash(true, '✅ Guardado'); }
    catch (e) { flash(false, '❌ ' + (e.response?.data?.error || 'No se pudo')); } finally { setBusy(false); }
  };
  const borrar = async (c) => { if (!window.confirm('¿Eliminar la capacitación?')) return; try { await sgsstCapacitaciones.remove(c.id); load(); } catch (e) {} };

  return (
    <div style={S.wrap}>
      <SgsstTabs />
      <div style={S.head}>
        <div><h1 style={S.h1}>Capacitaciones</h1><p style={S.sub}>Formación en SST con registro de asistencia.</p></div>
        <button style={S.btn} onClick={() => setM({ form: { ...VACIO, asistentes: [] } })}>+ Nueva capacitación</button>
      </div>
      {msgNode}
      <div style={S.card}><div style={{ overflowX: 'auto' }}>
        <table style={S.table}>
          <thead><tr>{['Fecha', 'Tema', 'Tipo', 'Horas', 'Modalidad', 'Asistentes', ''].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
          <tbody>
            {lista.length === 0 && <tr><td colSpan={7} style={S.empty}>Sin capacitaciones.</td></tr>}
            {lista.map(c => (
              <tr key={c.id}>
                <td style={S.td}>{fdate(c.fecha)}</td>
                <td style={{ ...S.td, color: '#e2e8f0' }}>{c.tema}</td>
                <td style={S.td}>{TIPO[c.tipo] || c.tipo}</td>
                <td style={{ ...S.td, textAlign: 'center' }}>{c.duracion_horas}</td>
                <td style={S.td}>{c.modalidad}</td>
                <td style={{ ...S.td, textAlign: 'center' }}>{c.asistentes || 0}</td>
                <td style={S.td}><button style={S.link} onClick={() => abrirEditar(c)}>Abrir</button><button style={{ ...S.link, color: '#fca5a5' }} onClick={() => borrar(c)}>Eliminar</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div></div>

      {m && <Modal title={m.id ? 'Editar capacitación' : 'Nueva capacitación'} onClose={() => setM(null)} wide>
        <F l="Tema"><input style={S.in} value={m.form.tema} onChange={e => setM({ ...m, form: { ...m.form, tema: e.target.value } })} /></F>
        <Grid3>
          <F l="Tipo"><select style={S.in} value={m.form.tipo} onChange={e => setM({ ...m, form: { ...m.form, tipo: e.target.value } })}>{Object.entries(TIPO).map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></F>
          <F l="Fecha"><input type="date" style={S.in} value={m.form.fecha} onChange={e => setM({ ...m, form: { ...m.form, fecha: e.target.value } })} /></F>
          <F l="Duración (horas)"><input type="number" step="0.5" style={S.in} value={m.form.duracion_horas} onChange={e => setM({ ...m, form: { ...m.form, duracion_horas: +e.target.value } })} /></F>
        </Grid3>
        <Grid3>
          <F l="Modalidad"><select style={S.in} value={m.form.modalidad} onChange={e => setM({ ...m, form: { ...m.form, modalidad: e.target.value } })}>{['presencial', 'virtual'].map(o => <option key={o} value={o}>{o}</option>)}</select></F>
          <F l="Instructor"><input style={S.in} value={m.form.instructor} onChange={e => setM({ ...m, form: { ...m.form, instructor: e.target.value } })} /></F>
          <F l="Lugar"><input style={S.in} value={m.form.lugar} onChange={e => setM({ ...m, form: { ...m.form, lugar: e.target.value } })} /></F>
        </Grid3>

        <div style={S.sec}>Asistentes ({m.form.asistentes.length})</div>
        <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
          <select style={{ ...S.in, flex: 1 }} value={addSel} onChange={e => setAddSel(e.target.value)}>
            <option value="">— Agregar manual —</option>
            {emp.map(e => <option key={e.id} value={e.id}>{e.nombre} · {e.numero_documento}</option>)}
          </select>
          <button style={S.btnSm} onClick={addAsistente}>+ Agregar</button>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 8 }}>
          {m.form.asistentes.map((a, i) => (
            <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'center', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '7px 10px' }}>
              <input placeholder="Nombre" style={{ ...S.in, flex: 1 }} value={a.nombre || ''} onChange={e => setAsis(i, 'nombre', e.target.value)} />
              <input placeholder="Doc." style={{ ...S.in, width: 110 }} value={a.documento || ''} onChange={e => setAsis(i, 'documento', e.target.value)} />
              <label style={{ color: '#94a3b8', fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}><input type="checkbox" checked={a.asistio !== false} onChange={e => setAsis(i, 'asistio', e.target.checked)} />Asistió</label>
              <button style={{ ...S.link, color: '#fca5a5', margin: 0 }} onClick={() => delAsis(i)}>✕</button>
            </div>
          ))}
        </div>
        <div style={S.modalBtns}><button style={S.btnGhost} onClick={() => setM(null)}>Cancelar</button><button style={S.btn} disabled={busy} onClick={guardar}>{busy ? 'Guardando…' : 'Guardar'}</button></div>
      </Modal>}
    </div>
  );
}
